// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aNNn0OhdEhzFGv {
  position: relative;
  margin-bottom: var(--ds-space-050, 4px);
  background-color: var(--ds-background-accent-gray-subtlest, #f1f2f4);
}
.aNNn0OhdEhzFGv:hover {
  background-color: var(--ds-background-accent-gray-subtler, #dcdfe4);
}
.aNNn0OhdEhzFGv::before {
  /* stylelint-disable-next-line plugin/ensure-disabled-design-token-domain */
  /* stylelint-disable design-system/ensure-design-token-usage */
  background: conic-gradient(from 180deg at 50% 50%, #ffa900 -52.2deg, #0065ff 89.76deg, #0469ff 145.8deg, #bf63f3 262.8deg, #ffa900 307.8deg, #0065ff 449.76deg);
  content: '';
  position: absolute;
  top: var(--ds-space-0, 0);
  right: var(--ds-space-0, 0);
  bottom: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  padding: var(--ds-space-025, 2px);
  border-radius: var(--ds-border-radius-100, 3px);
  -webkit-mask: linear-gradient(var(--ds-background-input, #ffffff) 0 0) content-box, linear-gradient(var(--ds-background-input, #ffffff) 0 0);
  mask-composite: exclude;
  pointer-events: none;
}
.aNNn0OhdEhzFGv .piexCq7fAMbwWf {
  display: flex;
  align-items: center;
  gap: var(--ds-space-100, 8px);
}
`, ""]);
// Exports
export var scheduleButton = `aNNn0OhdEhzFGv`;
export var scheduleButtonText = `piexCq7fAMbwWf`;
export default ___CSS_LOADER_EXPORT___;
